export default "__VITE_ASSET__399260cb__"